/**
 * Converts time (in seconds) to display text.
 */
export const secondsToDisplayText = (seconds: number): string => {
    const roundedSeconds = Math.round(seconds)

    if (roundedSeconds < 60) {
        return `${roundedSeconds} second${roundedSeconds === 1 ? '' : 's'}`
    }

    const minutes = Math.floor(roundedSeconds / 60)
    const hours = Math.floor(minutes / 60)

    // hours
    if (hours > 0) {
        const leftoverMinutes = minutes % 60
        let text = `${hours} hour${hours === 1 ? '' : 's'}`
        if (leftoverMinutes) {
            text += ` and ${leftoverMinutes} minute${leftoverMinutes === 1 ? '' : 's'}`
        }
        return text
    }

    // minutes
    const leftoverSeconds = roundedSeconds % 60
    let text = `${minutes} minute${minutes === 1 ? '' : 's'}`
    if (leftoverSeconds) {
        text += ` and ${leftoverSeconds} second${leftoverSeconds === 1 ? '' : 's'}`
    }
    return text
}

/**
 * Converts time (in seconds) to shortened display text.
 */
export const secondsToShortDisplayText = (seconds: number): string => {
    const roundedSeconds = Math.round(seconds)

    if (roundedSeconds < 60) {
        return `${roundedSeconds}s`
    }

    const minutes = Math.floor(roundedSeconds / 60)
    const hours = Math.floor(minutes / 60)

    // hours
    if (hours > 0) {
        const leftoverMinutes = minutes % 60
        let text = `${hours}h`
        if (leftoverMinutes) {
            text += ` ${leftoverMinutes}m`
        }
        return text
    }

    // minutes
    const leftoverSeconds = roundedSeconds % 60
    let text = `${minutes}m`
    if (leftoverSeconds) {
        text += ` ${leftoverSeconds}s`
    }
    return text
}

/**
 * Converts time (in seconds) to timestamp text.
 */
export const secondsToTimestamp = (seconds: number): string => {
    let ms = Math.floor((Math.floor((seconds * 1000) % 1000) / 1000) * 100)
    let s = Math.floor(seconds % 60)
    let m = Math.floor(((seconds * 1000) / (1000 * 60)) % 60)
    return 'M:SS.XX'
        .replace('M', `${m}`)
        .replace('SS', s < 10 ? `0${s}` : `${s}`)
        .replace('XX', ms < 10 ? `0${ms}` : `${ms}`)
}

/**
 * Converts file size (in megabytes) to display text.
 */
export const fileSizeToDisplayText = (megabytes: number): string => {
    if (!megabytes) return `0 megabytes`

    const gigabytes = megabytes / 1024
    if (gigabytes >= 1) {
        return `${Math.round(gigabytes * 10) / 10} gigabyte${gigabytes === 1 ? '' : 's'}`
    }
    return `${Math.round(megabytes)} megabyte${Math.round(megabytes) === 1 ? '' : 's'}`
}
